import { connect } from 'react-redux';
import { InsuranceChangeView } from './InsuranceChangeView';
import {
    clearCarrierAndPlan,
    choosePlan,
    chooseNonInsuranceOption,
}
    from '../../data/dropdown-state/dropdownStateActions';
import dropdownStateSelector from '../../data/dropdown-state/dropdownStateSelector';

const defaultCarrier = {
    name: '',
    id: -1,
    isDefault: true,
};

const defaultPlan = {
    name: null,
    id: -1,
};

export function mapStateToProps(state) {
    const dropdownState = dropdownStateSelector(state);

    const carrier = dropdownState.carrier || defaultCarrier;
    const plan = !carrier.isDefault && parseInt(carrier.id, 10) > 0 && dropdownState.plan
        ? dropdownState.plan
        : defaultPlan;

    return {
        planName: plan.name,
        carrierName: carrier.name,
        confirmSelection: props => {
            if (plan.name) {
                props.choosePlan(plan, null, false);
            } else if (carrier) {
                props.chooseNonInsuranceOption(carrier, false);
            }
        },
    };
}

export const mapDispatchToProps = {
    clearCarrierAndPlan,
    choosePlan,
    chooseNonInsuranceOption,
};

export const InsuranceChangeConnector = connect(
    mapStateToProps,
    mapDispatchToProps
)(InsuranceChangeView);
